import { toast } from 'react-hot-toast';
import {
  UpdateCommunityPostMutation,
  useUpdateCommunityPostMutation,
} from 'generated/graphql';

type Options = {
  onCompleted?: (data: UpdateCommunityPostMutation) => void;
};

export const useUpdatePost = ({ onCompleted }: Options = {}) =>
  useUpdateCommunityPostMutation({
    onCompleted: (data) => {
      toast.success('Post updated');
      onCompleted?.(data);
    },
    onError: () => toast.error('Something went wrong'),
  });
